import { render, staticRenderFns } from "./Occupation.vue?vue&type=template&id=74aac4a2&scoped=true"
import script from "./Occupation.vue?vue&type=script&lang=js"
export * from "./Occupation.vue?vue&type=script&lang=js"
import style0 from "./Occupation.vue?vue&type=style&index=0&id=74aac4a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74aac4a2",
  null
  
)

export default component.exports